import React, { useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelServiceContext, withViewModelService } from 'gw-portals-viewmodel-react';
import { useDependencies } from 'gw-portals-dependency-react';
import metadata from './AdditionalInsuredInterestComponent.metadata.json5';
import messages from './AdditionalInsuredInterestComponent.messages';
import styles from './AdditionalInsuredInterestComponent.module.scss';
import SearchContactComponent from '../SearchContact/SearchContactComponent';
import ContactComponent from '../Contact/ContactComponent';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';

function AdditionalInsuredInterestComponent(props) {
    const {
        coverableVM,
        type,
        onValueChange,
        authHeader,
        accountContacts,
        updateAccountContacts,
        accountNumber,
        updatePackage,
        isSubmission,
        jobID
    } = props;
    const types = {
        'additionalInsured': {
            path: 'additionalNamedInsureds',
            insuredPath: 'policyAdditionalInsured',
            dtoPath: 'edge.capabilities.quote.submission.base.dto.AdditionalNamedinsuredDTO'
        },
        'additionalInterest': {
            path: 'additionalInterests',
            insuredPath: 'policyAdditionalInterest',
            dtoPath: 'edge.capabilities.policyjob.lob.AdditionalInterestDTO'
        }
    };
    const { EndorsementService } = useDependencies('EndorsementService');
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);
    const path = types[type].path;
    const insuredPath = types[type].insuredPath;
    const dtoPath = types[type].dtoPath;
    const [searchInsuredInterest, setSearchInsuredInterest] = useState(false);
    const [addNewInsuredInterest, setAddNewInsuredInterest] = useState(false);
    const [newAdditionInsuredInterestAccounts, setNewAdditionalInsuredInterestAccounts] = useState([]);
    const [editContactVM, setEditContactVM] = useState({});
    const [editContactIndex, setEditContactIndex] = useState(-1)
    const [newContactVM, setNewContactVM] = useState({});
    const [newContactInsuredInterestVM, setNewContactInsuredInterestVM] = useState({});

    useEffect(() => {      
        setNewContactInsuredInterestVM(createAdditionalInsuredInterestVM({
            accountPublicId: "",
            hideNameField: false,
            type: ""
        }));
    }, []);

    const updateContacts = async (contact) => {
        const getContactService = isSubmission ? LoadSaveService : EndorsementService
        const updatedAccountContacts = await getContactService.getAccountContacts(jobID, authHeader);
        updateAccountContacts(updatedAccountContacts);
        setAdditionalInsuredInterest(updatedAccountContacts, contact.publicID);
        setSearchInsuredInterest(false);
    }

    const onAdditionalInsuredInterestChange = (value, model, props) => {
        if (value == "placeholder") {
            setSearchInsuredInterest(true);
        }
        else {
            setAdditionalInsuredInterest(accountContacts, value);
            setSearchInsuredInterest(false);
        }
    }

    const updateNewAdditionInsuredInterestContact = (data) => {
        let accounts = _.clone(newAdditionInsuredInterestAccounts);
        accounts.push(data);
        setNewAdditionalInsuredInterestAccounts(accounts);
        const additionalInsuredInterestContact = {
            hideNameField: false,
            type: newContactInsuredInterestVM.type.value.code
        };
        additionalInsuredInterestContact[`${insuredPath}`] = data;
        coverableVM[path].value.push(additionalInsuredInterestContact);
        updatePackage(coverableVM.value);
    }

    const setAdditionalInsuredInterest = (contactsAccount, publicID) => {
        var contactIdList = _.get(coverableVM, path).value ? _.get(coverableVM, path).value
            .filter((c) => { return c.accountPublicId; })
            .map((a) => { return a.accountPublicId; }) : [];
        if (contactIdList.indexOf(publicID) != -1) {
            return
        }
        let account = contactsAccount.filter((c) => { return c.publicID === publicID })[0];
        const additionalInsuredInterestContact = {
            accountPublicId: account.publicID,
            hideNameField: false,
            type: ""
        };
        additionalInsuredInterestContact[insuredPath] = account;
        coverableVM[path].value.push(additionalInsuredInterestContact);
        updatePackage(coverableVM.value);
    }

    const deleteAdditionalInsuredInterest = (index) => {
        coverableVM[path].value.splice(index, 1);
        updatePackage(coverableVM.value);
    }

    const editAdditionalInsuredInterest = (index) => {
        setEditContactIndex(index);
        const _contactVM = _.get(coverableVM, `${path}.children.${index}.${insuredPath}.value`);
        _contactVM.isFromPortal = true;
        _contactVM.primaryAddress.isFromPortal = true;
        _contactVM.isPhoneNonMandatory = true;
        setEditContactVM(createVM(_contactVM));
    }

    const handleInsuredInterestCancel = () => {
        setSearchInsuredInterest(false);
        setAddNewInsuredInterest(false);
    };

    //Search and add new contact container

    //Search

    const createVM = (model) => {
        return viewModelService.create(
            model,
            'pc',
            'edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO'
        );
    };

    const createAdditionalInsuredInterestVM = (model) => {
        return viewModelService.create(
            model,
            'pc',
            dtoPath
        );
    }

    const handleAddNewClick = () => {
        const contactModel = {
            subtype: "Person",
            primaryAddress: {
                country: "CA",
                state: "ON",
                isFromPortal: true
            },
            isFromPortal: true,
            isPhoneNonMandatory: true
        };
        setNewContactVM(createVM(contactModel));
        setSearchInsuredInterest(false);
        setAddNewInsuredInterest(true);
    }

    //Add New

    const saveContact = () => {
        const data = newContactVM.value
        data.displayName = data.firstName + ' ' + data.lastName;
        updateNewAdditionInsuredInterestContact(data);
        setSearchInsuredInterest(false);
        setAddNewInsuredInterest(false);
    }

    const cancelContact = () => {
        setSearchInsuredInterest(false);
        setAddNewInsuredInterest(false);
    }
    const onNewValueChange = (value, path) => {
        var _newContactVM = viewModelService.clone(newContactVM);
        _.set(_newContactVM, path, value)
        setNewContactVM(_newContactVM);
    }

    const onEditValueChange = (value, path, index) => {
        var _editContactVM = viewModelService.clone(editContactVM);
        _.set(_editContactVM, path, value);
        _.set(coverableVM, `${path}.children.${index}.${insuredPath}.value`, _editContactVM.value);
        setEditContactVM(_editContactVM);
    }

    const onCancelEditContact = () => {
        setEditContactVM({});
        setEditContactIndex(-1);
    }

    const onTypeChange = (value, model, props) => {
        const _newContactInsuredInterestVM = viewModelService.clone(newContactInsuredInterestVM);
        _.set(_newContactInsuredInterestVM, props.dataPath, value);
        setNewContactInsuredInterestVM(_newContactInsuredInterestVM);
    }

    const onSaveEditContact = (index) => {
        var _editContactVM = viewModelService.clone(editContactVM);
        _.set(coverableVM, `${path}.children.${index}.${insuredPath}.value`, _editContactVM.value);
        setEditContactVM({});
        setEditContactIndex(-1);
    }

    const generateOverrides = () => {

        const overrides = _.get(coverableVM, path).children.map((item, index) => {
            return {
                [`additionalNamedInsuredInterestName${index}`]: {
                    path: `${path}.children.${index}.${insuredPath}.displayName`
                },
                [`additionalInsuredInterestTitle${index}`]: {
                    content: `${getInsuredInterestTitle()} ${index + 1}`
                },
                [`additionalInsuredInterestType${index}`]: {
                    onValueChange: onValueChange,
                    label: (type == 'additionalInsured') ? translator(messages.additionalInsuredType) : translator(messages.additionalInterestType)
                },
                [`editAdditionalInsuredInterest${index}`]: {
                    onClick: (e) => { editAdditionalInsuredInterest(index) },
                    disabled: Object.keys(editContactVM).length > 0
                },
                [`deleteAdditionalInsuredInterest${index}`]: {
                    onClick: (e) => { deleteAdditionalInsuredInterest(index) },
                    disabled: Object.keys(editContactVM).length > 0
                },
                [`editContact${index}`]: {
                    contactVM: editContactVM,
                    onValueChange: (value, path) => { onEditValueChange(value, path, index) },
                    visible: editContactIndex === index
                },
                [`saveEditContact${index}`]: {
                    onClick: () => { onSaveEditContact(index) },
                    visible: editContactIndex === index,
                    disabled: editContactVM.aspects ? (!editContactVM.aspects.valid
                        || !editContactVM.aspects.subtreeValid) : false
                },
                [`cancelEditContact${index}`]: {
                    onClick: onCancelEditContact,
                    visible: editContactIndex === index
                }
            }
        })
        return Object.assign({}, ...overrides);
    }

    const getAdditionalInsuredInterestTitle = () => {
        if (_.get(coverableVM, path).children.length > 0) {
            return translator((type == 'additionalInsured') ? messages.anotherAdditionalNamedInsured : messages.anotherAdditionalInterest)
        }
        return getInsuredInterestTitle();
    }

    const getInsuredInterestTitle = () => {
        const titleKey = (type == 'additionalInsured') ? messages.additionalInsured : messages.additionalInterest
        return translator(titleKey);
    }


    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            onValueChange: onValueChange,
            showRequired: true
        },
        additionalInsuredInterestContainer: {
            model: coverableVM,
            path: `${path}.children`
        },
        additionalInsured: {
            availableValues: accountContacts,
            value: searchInsuredInterest,
            onValueChange: onAdditionalInsuredInterestChange,
            visible: (type == 'additionalInsured')
        },
        additionalInterest: {
            availableValues: accountContacts,
            value: searchInsuredInterest,
            onValueChange: onAdditionalInsuredInterestChange,
            visible: (type != 'additionalInsured')
        },
        addMoreContainer: {
            visible: !searchInsuredInterest && !addNewInsuredInterest
        },
        moreAdditionalInsuredInterestTitle: {
            content: getAdditionalInsuredInterestTitle()
        },
        searchContact: {
            visible: searchInsuredInterest,
            authHeader: authHeader,
            accountNumber: accountNumber,
            updateContacts: updateContacts,
            handleAddNew: handleAddNewClick,
            handleCancel: handleInsuredInterestCancel
        },
        addNewContainer: {
            visible: addNewInsuredInterest
        },
        newContactInsuredInterestType: {
            model: newContactInsuredInterestVM,
            visible: !_.isEmpty(
                _.get(
                    newContactInsuredInterestVM,
                    'type.aspects.availableValues'
                )
            ),
            dataPath:'type',
            value: _.get(
                newContactInsuredInterestVM,
                'type.value.code'
            ),
            availableValues: newContactInsuredInterestVM.type ? _.get(
                newContactInsuredInterestVM,
                'type.aspects.availableValues'
            ).map((type) => {
                return {code:type.code, displayName: translator({id:type.name})}
            }) : [],
            onValueChange: onTypeChange,
            label: (type == 'additionalInsured') ? translator(messages.additionalInsuredType) : translator(messages.additionalInterestType)
        },
        addContact: {
            contactVM: newContactVM,
            onValueChange: onNewValueChange
        },
        saveContactBtn: {
            onClick: saveContact,
            disabled: newContactVM.aspects ? (!newContactVM.aspects.valid
                || !newContactVM.aspects.subtreeValid) : false
        },
        cancelContactBtn: {
            onClick: cancelContact
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
        },
        resolveComponentMap: {
            searchContactComponent: SearchContactComponent,
            contactComponent: ContactComponent
        },
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={coverableVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

AdditionalInsuredInterestComponent.propTypes = {
    availableValues: PropTypes.array
}
export default AdditionalInsuredInterestComponent
